module.exports = __webpack_public_path__ + "static/media/auroraBorealis2.b8f359b6.jpg";